"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
var react_1 = require("react");
var INITIAL_STATE = {
    complete: false,
    dirty: false,
    error: null,
    submitting: false,
    submitted: false,
    valid: false,
};
function useForm(initial, deps, clearOnSubmit) {
    var _this = this;
    if (deps === void 0) { deps = []; }
    if (clearOnSubmit === void 0) { clearOnSubmit = false; }
    var getInitial = (0, react_1.useMemo)(function () { return (initial instanceof Function ? initial() : initial); }, __spreadArray([], deps, true));
    var formRef = (0, react_1.useRef)(null);
    var _a = (0, react_1.useState)(getInitial), formData = _a[0], setFormData = _a[1];
    var _b = (0, react_1.useState)(INITIAL_STATE), state = _b[0], setState = _b[1];
    var actions = {
        reset: function (resetState) {
            if (resetState === void 0) { resetState = false; }
            setFormData(getInitial);
            if (resetState) {
                setState(INITIAL_STATE);
            }
        },
        setData: function (data) {
            setFormData(data);
            setState(function (oldState) { return (__assign(__assign({}, oldState), { dirty: true, error: null })); });
        },
        setError: function (data) {
            setState(function (oldState) { return (__assign(__assign({}, oldState), { error: data })); });
        },
        setComplete: function () {
            setState(function (oldState) { return (__assign(__assign({}, oldState), { complete: true })); });
        },
        submit: function (callback) { return __awaiter(_this, void 0, void 0, function () {
            var callbackReturn;
            return __generator(this, function (_a) {
                callbackReturn = callback(formData);
                if (callbackReturn instanceof Promise) {
                    setState(function (oldState) { return (__assign(__assign({}, oldState), { submitting: true })); });
                    return [2 /*return*/, new Promise(function (resolve, reject) {
                            callbackReturn
                                .then(function () {
                                var args = [];
                                for (var _i = 0; _i < arguments.length; _i++) {
                                    args[_i] = arguments[_i];
                                }
                                if (clearOnSubmit) {
                                    actions.reset();
                                }
                                else {
                                    setState(function (oldState) { return (__assign(__assign({}, oldState), { dirty: false, error: null, submitting: false, submitted: true })); });
                                }
                                resolve.apply(void 0, args);
                            })
                                .catch(function () {
                                var args = [];
                                for (var _i = 0; _i < arguments.length; _i++) {
                                    args[_i] = arguments[_i];
                                }
                                setState(function (oldState) { return (__assign(__assign({}, oldState), { submitting: false })); });
                                reject.apply(void 0, args);
                            });
                        })];
                }
                return [2 /*return*/, Promise.resolve()];
            });
        }); },
    };
    var events = {
        onChange: function (event) {
            var _a = event.target, name = _a.name, value = _a.value;
            setFormData(function (oldState) {
                var _a;
                return (__assign(__assign({}, oldState), (_a = {}, _a[name] = value, _a)));
            });
            setState(function (oldState) { return (__assign(__assign({}, oldState), { dirty: true })); });
        },
    };
    (0, react_1.useEffect)(function () {
        actions.reset(true);
    }, __spreadArray([], deps, true));
    (0, react_1.useEffect)(function () {
        var _a;
        if (formRef.current !== null) {
            var valid_1 = (_a = formRef.current) === null || _a === void 0 ? void 0 : _a.checkValidity();
            setState(function (oldState) { return (__assign(__assign({}, oldState), { valid: valid_1 })); });
        }
    }, [formData]);
    return [formData, actions, events, state, formRef];
}
exports.default = useForm;
//# sourceMappingURL=index.js.map